<template>
  <iframe
    class="product-view-iframe"
    :src="frame.image"
    :title="frame.alt"
    frameborder="0"
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture;"
    allow-scripts
    allowfullscreen
    loading="lazy"
  ></iframe>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'

export default {
  props: {
    frame: {
      type: Object,
      required: true
    }
  },
  name: 'ProductIframe',
  mixins: [ReadyHook]
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';
.product-view-iframe {
  width: 100%;
  height: 100%;
}
</style>
